import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '../../components/LoadingSpinner';

const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [settings, setSettings] = useState({});
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${API_URL}/settings/logos`);
        if (response.ok) setSettings(await response.json());
      } catch (error) {
        console.error("Ayarlar yüklenemedi:", error);
      } finally {
        setPageLoading(false);
      }
    };
    fetchSettings();
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      await login(email, password);
      navigate('/'); // Başarılı giriş sonrası anasayfaya yönlendir
    } catch (err) {
      setError('Giriş başarısız: ' + err.message);
    }

    setLoading(false);
  }

  if (pageLoading) return <LoadingSpinner fullScreen />;

  return (
    <div className="min-h-screen flex">
      {/* Sol Taraf - Görsel */}
      <div 
        className="hidden lg:flex lg:w-1/2 bg-cover bg-center relative items-center justify-center"
        style={{ 
            backgroundImage: `url(${settings.loginImage || 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'})` 
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        <div className="relative z-10 text-white text-center p-12">
            <h1 className="text-5xl font-bold mb-6">Hoş Geldiniz</h1>
            <p className="text-xl font-light">Ramada by Wyndham Ergan<br/>Rezervasyon Yönetim Paneli</p>
        </div>
      </div>

      {/* Sağ Taraf - Giriş Formu */}
      <div className="w-full lg:w-1/2 flex items-center justify-center bg-white p-8">
        <div className="w-full max-w-md">
            <div className="text-center mb-10">
                {settings.light ? (
                    <img src={settings.light} alt="Logo" className="h-20 mx-auto mb-6 object-contain" />
                ) : (
                    <h2 className="text-4xl font-bold text-gray-800 mb-2">Ramada</h2>
                )}
                <h3 className="text-2xl font-semibold text-gray-700">Giriş Yap</h3>
                <p className="text-gray-500 mt-2">Devam etmek için lütfen giriş yapın.</p>
            </div>

            {error && <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 mb-6 text-sm rounded-r">{error}</div>}
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="email">
              E-posta
            </label>
            <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
              id="email"
              type="email"
              placeholder="ornek@ramada.com"
              value={email}
              onChange={(e) => setEmail(e.target.value.trim())}
              required
            />
          </div>
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="password">
              Şifre
            </label>
            <input
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
              id="password"
              type="password"
              placeholder="******************"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg transition duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
            type="submit"
            disabled={loading}
          >
            {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>
        <div className="mt-8 text-center">
            <p className="text-xs text-gray-400 font-medium">by AMC Fikir Sanat Rezervasyon Takip</p>
        </div>
      </div>
    </div>
    </div>
  );
}